import React from 'react'

interface HeroBannerProps {
  title: string
  description: string
  tag?: React.ReactNode
  primaryButton?: {
    text: string
    onClick: () => void
    icon?: React.ReactNode
  }
  secondaryButton?: {
    text: string
    onClick: () => void
  }
  rightContent?: React.ReactNode
  imageSrc?: string
}

export const HeroBanner: React.FC<HeroBannerProps> = ({
  title,
  description,
  tag,
  primaryButton,
  secondaryButton,
  rightContent,
  imageSrc
}) => {
  return (
    <div
      className="relative w-full flex flex-col lg:flex-row items-start lg:items-center justify-between px-6 lg:px-10 py-8 lg:py-10 overflow-hidden gap-6 lg:gap-0"
      style={{
        minHeight: '303px',
        background: '#ffffff',
        borderRadius: '24px',
        border: '1px solid #e0d4be',
        boxShadow: '0 4px 24px rgba(0,0,0,0.07)'
      }}
    >


      <div className="relative z-10 flex flex-col gap-4 flex-1 max-w-full lg:max-w-[580px]">
        {tag && (
          <span
            className="w-fit flex items-center gap-1.5 px-3 py-1 text-sm font-medium rounded-full"
            style={{
              color: '#7a6020',
              background: '#f5ede0',
              border: '1px solid #e0d4be'
            }}
          >
            {tag}
          </span>
        )}
        <h1
          style={{
            fontSize: 'clamp(24px, 3vw, 36px)',
            lineHeight: '1.15',
            fontWeight: 800,
            color: '#181820FF'
          }}
        >
          {title}
        </h1>
        <p
          className="line-clamp-2"
          style={{
            fontSize: '18px',
            lineHeight: '29px',
            fontWeight: 400,
            color: '#5A5A6DFF'
          }}
        >
          {description}
        </p>
        {(primaryButton || secondaryButton) && (
          <div className="flex items-center gap-3 mt-2">
            {primaryButton && (
              <button
                onClick={primaryButton.onClick}
                className="flex items-center justify-center gap-2 px-6 py-3"
                style={{
                  fontSize: '16px',
                  lineHeight: '26px',
                  fontWeight: 700,
                  color: '#FFFFFFFF',
                  background: '#7a6020',
                  borderRadius: '10px',
                  border: 'none',
                  cursor: 'pointer'
                }}
              >
                {primaryButton.icon}
                {primaryButton.text}
              </button>
            )}
            {secondaryButton && (
              <button
                onClick={secondaryButton.onClick}
                className="flex items-center justify-center px-6 py-3"
                style={{
                  fontSize: '16px',
                  lineHeight: '26px',
                  fontWeight: 700,
                  color: 'black',
                  background: '#f5ede0',
                  borderRadius: '10px',
                  border: '1px solid #e0d4be',
                  cursor: 'pointer'
                }}
              >
                {secondaryButton.text}
              </button>
            )}
          </div>
        )}
      </div>
      {(rightContent || imageSrc) && (
        <div className="relative z-10 flex-shrink-0 flex items-center justify-start lg:justify-center self-stretch w-full lg:w-auto min-w-0 overflow-hidden">
          {imageSrc && (
            <img
              src={imageSrc}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%'
              //  transform: 'scale(1)',
              //  transformOrigin: 'top left'
              }}
            />
          )}
          {rightContent && <div className="relative z-10">{rightContent}</div>}
        </div>
      )}
    </div>
  )
}
